import type { Candidate } from '@/types/candidate'

const placeholder = '/images/placeholders/no-image.jpg'

export const testCandidates: Candidate[] = [
  {
    id: 'fixture-candidate-quito-1',
    slug: 'candidato-prueba-quito-1',
    fullName: 'Candidato de prueba Quito 1',
    displayName: 'Prueba Quito 1',
    photoUrl: placeholder,
    provinceId: 'pichincha',
    provinceName: 'Pichincha',
    cantonId: 'quito',
    cantonName: 'Quito',
    dignityId: 'alcalde',
    dignityName: 'Alcalde/sa',
    politicalOrganizationId: 'organizacion-prueba-a',
    politicalOrganizationName: 'Organizacion de prueba A',
    ballotNumber: '00',
    shortBio: 'Perfil de prueba para validar componentes de candidatos.',
    proposals: [
      {
        id: 'movilidad',
        title: 'Movilidad',
        summary: 'Propuesta de prueba para validar visualización.',
      },
      {
        id: 'seguridad',
        title: 'Seguridad',
        summary: 'Propuesta de prueba para validar comparador.',
      },
    ],
    featured: true,
    fixture: true,
  },
  {
    id: 'fixture-candidate-guayaquil-1',
    slug: 'candidato-prueba-guayaquil-1',
    fullName: 'Candidata de prueba Guayaquil 1',
    displayName: 'Prueba Guayaquil 1',
    photoUrl: placeholder,
    provinceId: 'guayas',
    provinceName: 'Guayas',
    cantonId: 'guayaquil',
    cantonName: 'Guayaquil',
    dignityId: 'alcalde',
    dignityName: 'Alcalde/sa',
    politicalOrganizationId: 'organizacion-prueba-b',
    politicalOrganizationName: 'Organizacion de prueba B',
    ballotNumber: '00',
    shortBio: 'Perfil de prueba para validar filtros territoriales.',
    proposals: [
      {
        id: 'servicios-basicos',
        title: 'Servicios basicos',
        summary: 'Propuesta de prueba para validar fichas.',
      },
    ],
    fixture: true,
  },
  {
    id: 'fixture-candidate-quito-2',
    slug: 'candidato-prueba-quito-2',
    fullName: 'Candidato de prueba Quito 2',
    displayName: 'Prueba Quito 2',
    photoUrl: placeholder,
    provinceId: 'pichincha',
    provinceName: 'Pichincha',
    cantonId: 'quito',
    cantonName: 'Quito',
    dignityId: 'prefecto',
    dignityName: 'Prefecto/a',
    politicalOrganizationId: 'organizacion-prueba-b',
    politicalOrganizationName: 'Organizacion de prueba B',
    ballotNumber: '00',
    shortBio: 'Perfil de prueba para validar candidatos provinciales en la pagina de ciudad.',
    proposals: [
      {
        id: 'ambiente',
        title: 'Ambiente',
        summary: 'Propuesta de prueba para validar componentes territoriales.',
      },
    ],
    fixture: true,
  },
  {
    id: 'fixture-candidate-quito-3',
    slug: 'candidato-prueba-quito-3',
    fullName: 'Candidata de prueba Quito 3',
    displayName: 'Prueba Quito 3',
    photoUrl: placeholder,
    provinceId: 'pichincha',
    provinceName: 'Pichincha',
    cantonId: 'quito',
    cantonName: 'Quito',
    dignityId: 'concejal',
    dignityName: 'Concejal/a',
    politicalOrganizationId: 'organizacion-prueba-c',
    politicalOrganizationName: 'Organizacion de prueba C',
    ballotNumber: '00',
    shortBio: 'Perfil de prueba para validar candidaturas al Concejo.',
    proposals: [
      {
        id: 'espacio-publico',
        title: 'Espacio publico',
        summary: 'Propuesta de prueba para validar listados compactos.',
      },
    ],
    fixture: true,
  },
  {
    id: 'fixture-candidate-cuenca-1',
    slug: 'candidato-prueba-cuenca-1',
    fullName: 'Candidato de prueba Cuenca 1',
    displayName: 'Prueba Cuenca 1',
    photoUrl: placeholder,
    provinceId: 'azuay',
    provinceName: 'Azuay',
    cantonId: 'cuenca',
    cantonName: 'Cuenca',
    dignityId: 'prefecto',
    dignityName: 'Prefecto/a',
    politicalOrganizationId: 'organizacion-prueba-c',
    politicalOrganizationName: 'Organizacion de prueba C',
    ballotNumber: '00',
    shortBio: 'Perfil de prueba para validar dignidades distintas.',
    proposals: [
      {
        id: 'obras-publicas',
        title: 'Obras publicas',
        summary: 'Propuesta de prueba para validar listados.',
      },
    ],
    fixture: true,
  },
]
